import { Access } from '../../enums';
import { Permission } from '../permission';

const EMPLOYEES_KEY = 'employees';
export const EMPLOYEES = {
  READ: new Permission({
    key: `${EMPLOYEES_KEY}:global:${Access.READ}`,
    description: 'Mitarbeiter L',
  }),

  WRITE: new Permission({
    key: `${EMPLOYEES_KEY}:global:${Access.WRITE}`,
    description: 'Mitarbeiter S',
  }),

  GENERAL: {
    READ: new Permission({
      key: `${EMPLOYEES_KEY}:general:${Access.READ}`,
      description: 'Mitarbeiter-Persönlich L',
    }),

    WRITE: new Permission({
      key: `${EMPLOYEES_KEY}:general:${Access.WRITE}`,
      description: 'Mitarbeiter-Persönlich  S',
    }),
  },

  CONTRACT: {
    READ: new Permission({
      key: `${EMPLOYEES_KEY}:contract:${Access.READ}`,
      description: 'Mitarbeiter-Vertragsdaten L',
    }),

    WRITE: new Permission({
      key: `${EMPLOYEES_KEY}:contract:${Access.WRITE}`,
      description: 'Mitarbeiter-Vertragsdaten  S',
    }),
  },

  SYSTEM_ACCESS: {
    READ: new Permission({
      key: `${EMPLOYEES_KEY}:system-access:${Access.READ}`,
      description: 'Mitarbeiter-Systemzugriff L',
    }),

    WRITE: new Permission({
      key: `${EMPLOYEES_KEY}:system-access:${Access.WRITE}`,
      description: 'Mitarbeiter-Systemzugriff S',
    }),
  },

  CHECKLIST: {
    READ: new Permission({
      key: `${EMPLOYEES_KEY}:checklist:${Access.READ}`,
      description: 'Mitarbeiter-Unterlagen L',
    }),

    WRITE: new Permission({
      key: `${EMPLOYEES_KEY}:checklist:${Access.WRITE}`,
      description: 'Mitarbeiter-Unterlagen S',
    }),
  },

  FILES: {
    READ: new Permission({
      key: `${EMPLOYEES_KEY}:documents:${Access.READ}`,
      description: 'Mitarbeiter-Dokumente L',
    }),

    WRITE: new Permission({
      key: `${EMPLOYEES_KEY}:documents:${Access.WRITE}`,
      description: 'Mitarbeiter-Dokumente S',
    }),

    DELETE: new Permission({
      key: `${EMPLOYEES_KEY}:documents:${Access.DELETE}`,
      description: 'Mitarbeiter-Dokumente Löschen',
    }),
  },

  WORK: {
    READ: new Permission({
      key: `${EMPLOYEES_KEY}:work:${Access.READ}`,
      description: 'Mitarbeiter-Arbeit L',
    }),

    WRITE: new Permission({
      key: `${EMPLOYEES_KEY}:work:${Access.WRITE}`,
      description: 'Mitarbeiter-Arbeit S',
    }),
  },

  CALENDAR: {
    READ: new Permission({
      key: `${EMPLOYEES_KEY}:calendar:${Access.READ}`,
      description: 'Mitarbeiter-Kalender L',
    }),

    WRITE: new Permission({
      key: `${EMPLOYEES_KEY}:calendar:${Access.WRITE}`,
      description: 'Mitarbeiter-Kalender S',
    }),
  },

  VACATION: {
    READ: new Permission({
      key: `${EMPLOYEES_KEY}:vacation:${Access.READ}`,
      description: 'Mitarbeiter-Urlaub L',
    }),

    WRITE: new Permission({
      key: `${EMPLOYEES_KEY}:vacation:${Access.WRITE}`,
      description: 'Mitarbeiter-Urlaub S',
    }),
  },

  MISC: {
    READ: new Permission({
      key: `${EMPLOYEES_KEY}:miscellaneous:${Access.READ}`,
      description: 'Mitarbeiter-Sonstiges L',
    }),

    WRITE: new Permission({
      key: `${EMPLOYEES_KEY}:miscellaneous:${Access.WRITE}`,
      description: 'Mitarbeiter-Sonstiges S',
    }),
  },

  TRAINING: {
    READ: new Permission({
      key: `${EMPLOYEES_KEY}:training:${Access.READ}`,
      description: 'Mitarbeiter-Schulung L',
    }),

    WRITE: new Permission({
      // TODO: which Role is entitled to write training data?
      key: `${EMPLOYEES_KEY}:training:${Access.WRITE}`,
      description: 'Mitarbeiter-Schulung S',
    }),
  },
};
